import { Flex, Text } from '@fluentui/react-northstar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { appState } from '../../AppState';

export const AccessDenied = () => {
    const {t} = useTranslation();
    const { userRoles } = appState();

    // Whoever lands here has nowhere to go from this page, so give them the way
    // out - the portal they actually belong to. An end user has no agent portal
    // to return to. #35097
    const home = userRoles.isAuthorizedAgent ? '/' : '/requests';

    return (
        <Flex hAlign="center" vAlign="center" column gap="gap.small" className={`h-screen`}>
            <Flex hAlign="center" vAlign="center">
                <Text className={`m-0`} size="largest">{t('common.access-denied')}</Text>
            </Flex>
            <Link to={home}>
                <Text color="brand" weight="semibold" content={t('common.go-home')} />
            </Link>
        </Flex>
    )
}
